import useSWR from 'swr';

export interface BackupStatus {
  enabled: boolean;
  endpoint: string;
  bucket: string;
  writes_attempted?: number;
  writes_ok?: number;
  writes_failed?: number;
  bytes_written?: number;
  last_success_at?: string;
  last_failure_at?: string;
  last_failure_msg?: string;
  pending_failures: number;
  pending_async: number;
  recovered_total: number;
  async_mode: boolean;
  read_fallback: boolean;
  strict_mode: boolean;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useBackupStatus() {
  return useSWR<BackupStatus>('/api/admin/backup', fetcher, { refreshInterval: 30_000 });
}
